var map = {
	"./info-sharing-center-de.html": 1022,
	"./info-sharing-center-en.html": 1023,
	"./info-sharing-center-es.html": 1024,
	"./info-sharing-center-fr.html": 1025,
	"./info-sharing-center-ja.html": 1026,
	"./info-sharing-center-pt.html": 1027,
	"./info-sharing-center-zh.html": 1028
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 1021
// module chunks = 0